module.exports = __webpack_public_path__ + "media/explosion.0a3b4a26.wav";